import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { withTranslation } from "react-i18next";

import {
  updateForm,
  getCommonApi,
  commonCreateApi,
} from "redux/actions/common";
import {
  CommonTable,
  NormalInput,
  SearchInputKeyboard,
} from "component/common";
import { Toast } from "service/toast";
import RequestMessage from "./RequestMessage";

import "./style.scss";
import CustomerUserList from "./CustomerUserList";
export class CustomerOutletClass extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      formFields: {
        custId: "",
        custName: "",
        cust_phone2: "",
        site_code: "",
      },
      visible: false,
      customerOption: [],
      transferCheckbox: false,
      searchInputValue: "",
      customerRequestList: {},

      customerRequestResponse: {
        message: "",
        dateTime: "",
      },
      hideRequestBtn: true,
      inputValueChild: "",
      requestCount: {},
    };
  }

  // outletrequestcustomer initial call
  componentDidMount = () => {
    this.outletrequestcustomerList();
  };

  // outletrequestcustomer
  outletrequestcustomerList = () => {
    let dateFormat = moment().format("YYYY-MM-DD");
    this.props
      .getCommonApi(`outletrequestcustomer/?given_date=${dateFormat}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          this.setState({ requestCount: data });
          const groupdData = data.list_data.reduce((groups, person) => {
            const group = groups[person.req_status] || [];
            group.push(person);
            groups[person.req_status] = group;
            return groups;
          }, {});

          this.setState({ customerRequestList: groupdData });
        }
      });
  };

  // handleClickRequest
  handleClickRequest = () => {
    let { custId } = this.state.formFields;
    let body = {
      cust_id: custId,
      is_permanent: this.state.transferCheckbox,
    };
    this.props.commonCreateApi(`outletrequestcustomer/`, body).then((res) => {
      let { status, message } = res;
      if (status === 200) {
        this.outletrequestcustomerList();
        let { customerRequestResponse } = this.state;
        customerRequestResponse.message = message;
        const dateFormartConvert = moment().format("DD/MM/YYYY hh:mm A");
        customerRequestResponse.dateTime = dateFormartConvert;
        this.setState({ customerRequestResponse });
        Toast({
          type: "success",
          message: "Request Confirmed Successfully",
        });
        // window.location.reload();
        this.handleSetInitialState();
      }
    });
  };

  // handleSetInitialState

  handleSetInitialState = () => {
    let customerTempRes = {
      message: "",
      dateTime: "",
    };
    this.setState({
      searchInputValue: "",
      customerRequestResponse: customerTempRes,
      formFields: {
        custId: "",
        custName: "",
        cust_phone2: "",
        site_code: "",
      },
      transferCheckbox: false,
    });
  };

  handleClick = () => {
    if (!this.state.visible) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({ visible: true });
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };
  search = (searchString) => {
    this.props
      .getCommonApi(
        `custappt/?search=${searchString}&customeroutletrestrict=1
      `
      )
      .then(async (key) => {
        let { status, data } = key;
        if (status === 200) {
          await this.setState({ customerOption: data });
        }
      });
    //}
  };
  // handle search
  handleSearch = async (text) => {
    await this.setState({ searchInputValue: text });
  };

  handleIconSearch = async () => {
    await this.setState({ visible: true });
    let data = this.state.searchInputValue ?? "";
    await this.search(data);
  };

  // handleSelectCustomer
  handleSelectCustomer = async (data) => {
    let { formFields } = this.state;
    let { id, cust_name, site_code, cust_phone2 } = data;
    formFields["custId"] = id;
    formFields["custName"] = cust_name;
    formFields["site_code"] = site_code;
    formFields["cust_phone2"] = cust_phone2;

    await this.setState({
      formFields,
      searchInputValue: cust_name,
      search: "",
      customerOption: [],
      hideRequestBtn: true,
      customerRequestResponse: {},
    });

    await this.props.updateForm("basicApptDetail", formFields);
    this.handleClick();
    if (this.props.tokenDetails.ipadkey && cust_name) {
      this.child.parentDataUpdate(cust_name);
    }
  };

  // handlecheckCheckbox

  handleChangeBox = () => {
    this.setState({ transferCheckbox: !this.state.transferCheckbox });
  };

  // handleSwitchUser
  handleSwitchUser = async (data) => {
    let { formFields } = this.state;
    let {
      id,
      cust_name,
      from_site,
      cust_phone,
      requesting_site,
      req_status,
      log_date,
    } = data;

    formFields["custId"] = id;
    formFields["custName"] = cust_name;
    formFields["site_code"] = from_site;
    formFields["cust_phone2"] = cust_phone;
    let { customerRequestResponse } = this.state;
    customerRequestResponse.message = ` Your Customer Request has been forwarded to ${requesting_site} outlet and ${req_status} for approval`;
    customerRequestResponse.dateTime = log_date;

    await this.setState({
      formFields,
      searchInputValue: cust_name,
      hideRequestBtn: false,
      customerRequestResponse,
    });
  };

  // handleCloseIconClick
  handleClose = () => this.setState({ visible: false });

  render() {
    let {
      formFields,
      visible,
      customerOption,
      customerRequestList,
      customerRequestResponse,
      hideRequestBtn,
      requestCount,
    } = this.state;
    return (
      <div id="customerOutletContainer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="customerOutletHeader">
                <h6 className="custTitle">customer outlet Request </h6>
              </div>
            </div>
          </div>

          <div className="row">
            <CustomerUserList
              customerRequestList={customerRequestList}
              handleSwitchUser={(item) => this.handleSwitchUser(item)}
              requestCount={requestCount}
            />

            <div className="col-md-9">
              <div className="outletCustomerSearchContainer">
                <div className="row my-3">
                  <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-4">
                    {this.props.tokenDetails.ipadkey ? (
                      <SearchInputKeyboard
                        onRef={(ref) => (this.child = ref)}
                        onChangeTextInput={(e) => this.handleSearch(e)}
                        handleIconSearch={() => {
                          this.handleIconSearch();
                        }}
                        handleHideModal={(val) =>
                          this.setState({ visible: val })
                        }
                        focusValue={"customerOutletInput"}
                        placeHolderText={"Search Customer.."}
                        keyboardModalValue
                        parentPassIntialValue={this.state.searchInputValue}
                      />
                    ) : (
                      <NormalInput
                        placeholder="Search Customer.."
                        value={this.state.searchInputValue}
                        name="custName"
                        onChange={(e) => this.handleSearch(e.target.value)}
                        iconsVisible
                        onClickIcon={() => {
                          this.handleIconSearch();
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    {visible ? (
                      <CommonTable
                        customerOption={customerOption}
                        handleSelectCustomer={this.handleSelectCustomer}
                        handleClose={() => this.handleClose()}
                      />
                    ) : null}
                  </div>
                </div>
                <RequestMessage
                  formFields={formFields}
                  transferCheckbox={this.state.transferCheckbox}
                  handleChangeBox={() => this.handleChangeBox()}
                  hideRequestBtn={hideRequestBtn}
                  handleClickRequest={() => this.handleClickRequest()}
                  customerRequestResponse={customerRequestResponse}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  basicApptDetail: state.appointment.basicApptDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
    },
    dispatch
  );
};

export const CustomerOutlet = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(CustomerOutletClass)
);
